"use client";

import { Link } from "@/components/common/Link";
export default function Commercial() {
  return <section data-section-id="1400" id="commercial-accounts-hero" className="bg-background text-foreground min-h-screen relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        {}
        <div className="lg:col-span-9 relative flex items-center justify-center lg:p-12 p-6">
          <div className="relative w-full lg:aspect-[4/5] aspect-[3/4] max-h-screen" style={{
          boxShadow: "0 0 0 12px transparent, 0 0 0 13px hsl(222 47% 11% / 0.1)"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_vessel_deck.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_vessel_deck.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_vessel_deck.webp-wvc-sizes" alt="The Miss Yvonne fishing vessel deck prepared for a commercial haul" loading="eager" decoding="async" className="w-full h-full object-cover" />
          </div>

          {}
          <div className="hidden lg:block absolute bottom-8 left-8 font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
            30° 24' 42" N / 88° 49' 42" W — Ocean Springs
          </div>
        </div>

        {}
        <div className="lg:col-span-3 flex flex-col justify-center lg:px-[5vw] px-6 lg:py-16 py-12 relative">
          {}
          <div className="flex items-center gap-4 mb-12">
            <span className="font-mono text-[12px] tracking-[0.22em] uppercase" style={{
            color: "hsl(215 60% 35%)"
          }}>
              § N° 05 
            </span>
            <span className="h-px w-10 hidden lg:block" style={{
            backgroundColor: "hsl(215 60% 35%)"
          }} />
          </div>

          {}
          <h1 className="font-serif font-normal text-foreground" style={{
          fontSize: "clamp(3.5rem, 8.2vw, 8.75rem)",
          letterSpacing: "-0.025em",
          lineHeight: "0.95"
        }}>
            <span className="block">Quality</span>
            <span className="block">for</span>
            <span className="block">
              your{" "}
              <span className="italic" style={{
              color: "hsl(215 60% 35%)"
            }}>
                galley.
              </span>
            </span>
          </h1>

          {}
          <div className="flex items-center mt-12 mb-8">
            <span className="h-px w-[120px] block" style={{
            backgroundColor: "hsl(215 60% 35%)"
          }} />
            <span className="ml-2 inline-block w-1.5 h-1.5 rounded-lg" style={{
            backgroundColor: "hsl(215 60% 35%)"
          }} aria-hidden="true" />
          </div>

          {}
          <p className="font-sans text-muted-foreground max-w-md" style={{
          fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
          lineHeight: "1.65",
          letterSpacing: "0.005em"
        }}>
            Premium wild-caught seafood solutions for restaurants and markets, delivered with heritage care.
          </p>

          {}
          <div className="mt-16">
            <Link to="/ContactPage" className="inline-flex items-center gap-2 font-sans text-[15px] tracking-[0.005em] underline underline-offset-[6px] decoration-1 hover:decoration-2 transition-all duration-200" style={{
            color: "hsl(215 60% 35%)"
          }}>
              Partner with us →
            </Link>
          </div>

          {}
          <div className="lg:hidden mt-16 font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
            30° 24' 42" N / 88° 49' 42" W — Ocean Springs
          </div>
        </div>
      </div>
    </section>;
}